<script>
import Wysiwyg from '@wielink-application/shared/vue/components/form/input-only/wysiwyg.vue';

export default Wysiwyg;
</script>